export default "__VITE_ASSET__H5Ua0RId__"